/* ARCTA VIP-Wochenende 2026 – Countdown, Anmeldung (Klaviyo Client API), Sticky-Leiste mobil
   Startet beim Laden und für jede Section, die der Theme-Editor neu lädt (shopify:section:load). */
(function () {
  if (window.__arctaVip) return;
  window.__arctaVip = true;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };
  var toArr = function (list) { return Array.prototype.slice.call(list); };
  var fresh = function (root, sel) { return toArr(root.querySelectorAll(sel)).filter(function (el) { if (el.hasAttribute('data-vip-init')) return false; el.setAttribute('data-vip-init', ''); return true; }); };

  function remaining(target) {
    var diff = Math.max(0, Math.floor((target - Date.now()) / 1000));
    return { total: diff, d: Math.floor(diff / 86400), h: Math.floor(diff % 86400 / 3600), m: Math.floor(diff % 3600 / 60), s: diff % 60 };
  }

  /* Gemerkter Zustand „eingetragen“ (gilt seitenübergreifend für Leiste, PDP-Block, Banner, Popup) */
  var KEY = 'arcta_vip26';
  var store = {
    get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }
  };
  function markSigned() { store.set(KEY, '1'); document.documentElement.classList.add('avp-signed'); }
  if (store.get(KEY) === '1') document.documentElement.classList.add('avp-signed');

  function track(name, params) {
    try { window.dataLayer = window.dataLayer || []; var o = { event: name }; for (var k in params) o[k] = params[k]; window.dataLayer.push(o); } catch (x) {}
  }

  /* Countdowns: eine gemeinsame Uhr für alle Elemente */
  var items = [], timer = null;
  function tick() {
    items = items.filter(function (it) { return it.el.isConnected; });
    items.forEach(function (it) {
      var r = remaining(it.t);
      if (it.until) { if (r.total === 0) it.el.remove(); return; }
      if (it.inline) { it.el.textContent = (r.d > 0 ? r.d + ' T ' : '') + pad(r.h) + ':' + pad(r.m) + ':' + pad(r.s); return; }
      if (it.sticky) { it.el.textContent = r.total === 0 ? 'jetzt' : r.d + ' T · ' + r.h + ' Std · ' + pad(r.m) + ' Min'; return; }
      if (r.total === 0) {
        if (!it.el.classList.contains('is-done')) { it.el.classList.add('is-done'); var d = it.el.parentElement && it.el.parentElement.querySelector('[data-vip-done]'); if (d) d.hidden = false; }
        return;
      }
      var vals = { d: r.d, h: it.hours ? Math.floor(r.total / 3600) : r.h, m: r.m, s: r.s };
      ['d', 'h', 'm', 's'].forEach(function (k) { var b = it.el.querySelector('[data-cd="' + k + '"]'); if (b) b.textContent = pad(vals[k]); });
    });
    if (!items.length && timer) { clearInterval(timer); timer = null; }
  }
  function initCountdowns(root) {
    fresh(root, '[data-vip-countdown]').forEach(function (el) { var t = Date.parse(el.getAttribute('data-target')); if (!isNaN(t)) items.push({ el: el, t: t, hours: el.getAttribute('data-mode') === 'hours' }); });
    fresh(root, '[data-vip-sticky-time]').forEach(function (el) { var t = Date.parse(el.getAttribute('data-target')); if (!isNaN(t)) items.push({ el: el, t: t, sticky: true }); });
    fresh(root, '[data-vip-inline]').forEach(function (el) { var t = Date.parse(el.getAttribute('data-target')); if (!isNaN(t)) items.push({ el: el, t: t, inline: true }); });
    toArr(root.querySelectorAll('[data-vip-until]')).forEach(function (el) {
      if (el.hasAttribute('data-vip-until-init')) return;
      el.setAttribute('data-vip-until-init', '');
      var t = Date.parse(el.getAttribute('data-vip-until'));
      if (isNaN(t)) return;
      if (t <= Date.now() && !(window.Shopify && Shopify.designMode)) { el.remove(); return; }
      items.push({ el: el, t: t, until: true });
    });
    if (items.length && !timer) timer = setInterval(tick, 1000);
    tick();
  }

  function utm(name) {
    try { return new URLSearchParams(window.location.search).get(name) || undefined; } catch (e) { return undefined; }
  }

  function icsHref(start, title) {
    var d = new Date(Date.parse(start));
    var fmt = function (x) { return x.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
    var end = new Date(d.getTime() + 60 * 60 * 1000);
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//ARCTA//VIP-Wochenende//DE', 'BEGIN:VEVENT',
      'UID:vip-wochenende-' + d.getTime() + '@arcta.de', 'DTSTAMP:' + fmt(new Date()), 'DTSTART:' + fmt(d), 'DTEND:' + fmt(end),
      'SUMMARY:' + title, 'URL:https://www.arcta.de/collections/vip-sale', 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    return 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics);
  }

  /* Anmeldung → Klaviyo-Liste */
  function initForms(root) {
    fresh(root, '[data-vip-form]').forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var error = form.querySelector('[data-vip-error]');
      var success = form.querySelector('[data-vip-success]');
      var cal = form.querySelector('[data-vip-ics]');
      if (cal) { cal.href = icsHref(cal.getAttribute('data-start'), cal.getAttribute('data-title') || 'ARCTA VIP-Wochenende'); }
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        error.hidden = true;
        var email = (input.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
          error.textContent = form.getAttribute('data-msg-invalid');
          error.hidden = false;
          input.focus();
          return;
        }
        form.classList.add('is-loading');
        var props = { vip26_signup_page: window.location.pathname, vip26_quelle: form.getAttribute('data-source') || undefined };
        if (form.getAttribute('data-product')) props.vip26_product = form.getAttribute('data-product');
        ['utm_source', 'utm_medium', 'utm_campaign'].forEach(function (k) { var v = utm(k); if (v) props['vip26_' + k] = v; });
        var body = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.getAttribute('data-source'),
              profile: { data: { type: 'profile', attributes: { email: email, properties: props, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
            },
            relationships: { list: { data: { type: 'list', id: form.getAttribute('data-list') } } }
          }
        };
        fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(form.getAttribute('data-company')), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2026-07-15' },
          body: JSON.stringify(body)
        }).then(function (res) {
          form.classList.remove('is-loading');
          if (res.status === 202 || res.ok) {
            form.classList.add('is-done');
            success.hidden = false;
            track('vip_signup', { vip_source: form.getAttribute('data-source') });
            markSigned();
            form.dispatchEvent(new CustomEvent('vip:signed', { bubbles: true }));
            document.querySelectorAll('[data-vip-form]').forEach(function (f) { if (f !== form) { f.classList.add('is-done'); var s = f.querySelector('[data-vip-success]'); if (s) s.hidden = false; } });
            updateSticky();
          } else {
            error.textContent = form.getAttribute('data-msg-error');
            error.hidden = false;
          }
        }).catch(function () {
          form.classList.remove('is-loading');
          error.textContent = form.getAttribute('data-msg-error');
          error.hidden = false;
        });
      });
    });
  }

  /* Sticky-Leiste mobil: sichtbar, wenn kein Formular im Bild ist */
  var io = null, inView = new Map(), stickyBar = null;
  function updateSticky() {
    if (!stickyBar || !stickyBar.isConnected) return;
    var forms = toArr(document.querySelectorAll('[data-vip-form]'));
    var done = forms.some(function (f) { return f.classList.contains('is-done'); });
    var anyVisible = false; inView.forEach(function (v, el) { if (v && el.isConnected) anyVisible = true; });
    var show = !anyVisible && !done && window.scrollY > 200;
    stickyBar.classList.toggle('is-visible', show);
    document.documentElement.classList.toggle('avip-sticky-on', show);
    document.documentElement.classList.toggle('avip-form-in-view', anyVisible && !done);
  }
  function initSticky() {
    var bar = document.querySelector('[data-vip-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    if (io) io.disconnect();
    inView = new Map();
    stickyBar = bar;
    io = new IntersectionObserver(function (entries) { entries.forEach(function (en) { inView.set(en.target, en.isIntersecting); }); updateSticky(); });
    toArr(document.querySelectorAll('[data-vip-form]')).forEach(function (f) { io.observe(f); });
  }
  window.addEventListener('scroll', updateSticky, { passive: true });

  /* Buttons mit data-vip-jump (Sticky-Leiste, Hinweis-Kasten): weich zum ersten Formular, Feld fokussieren */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('[data-vip-jump]');
    var first = link && document.querySelector('[data-vip-form]');
    if (!first) return;
    e.preventDefault();
    first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var inp = first.querySelector('input[type="email"]'); if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 400);
  });

  /* VIP-Popup (snippets/arcta-vip-popup.liquid): nach X Sekunden, 50 % Scroll oder beim Verlassen (Desktop).
     Nie für Eingetragene, nie für Besucher aus Klaviyo-Mails (_kx / utm_source=klaviyo), nach „Nein danke“ X Tage Pause.
     Test: ?vippop=1 zeigt es sofort, ohne diese Sperren. */
  function initPopup() {
    var pop = document.querySelector('[data-vip-popup]');
    if (!pop || pop.hasAttribute('data-vip-pop-init')) return;
    pop.setAttribute('data-vip-pop-init', '');
    var params = null; try { params = new URLSearchParams(window.location.search); } catch (e) {}
    var force = !!params && params.get('vippop') === '1';
    var PAUSE = 'arcta_vip26_popup_pause', KNOWN = 'arcta_vip26_known';
    if (params && (params.get('_kx') || /klaviyo/i.test(params.get('utm_source') || ''))) store.set(KNOWN, '1');
    if (!force) {
      if (window.Shopify && Shopify.designMode) return;
      if (store.get(KEY) === '1' || store.get(KNOWN) === '1') return;
      var until = parseInt(store.get(PAUSE) || '0', 10);
      if (until && Date.now() < until) return;
    }
    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 15) * 1000;
    var pauseDays = parseInt(pop.getAttribute('data-pause'), 10) || 3;
    var lastFocus = null, shown = false, t = null;
    function busy() {
      var b = document.body.classList;
      if (b.contains('js-drawer-open') || b.contains('js-drawer-open-right') || b.contains('js-drawer-open-left')) return true;
      var banner = document.getElementById('shopify-pc__banner');
      return !!(banner && banner.offsetParent !== null);
    }
    function onScroll() { var h = document.documentElement.scrollHeight - window.innerHeight; if (h > 0 && window.scrollY / h > 0.5) open('scroll'); }
    function onLeave(e) { if (!e.relatedTarget && e.clientY <= 0) open('exit'); }
    function cleanup() { clearTimeout(t); window.removeEventListener('scroll', onScroll); document.removeEventListener('mouseout', onLeave); }
    function open(reason) {
      if (shown || !pop.isConnected) return;
      /* Wer sich inzwischen auf der Seite eingetragen hat (Banner, Hero, PDP-Block), bekommt kein Popup mehr */
      if (!force && (store.get(KEY) === '1' || document.documentElement.classList.contains('avp-signed'))) { cleanup(); return; }
      if (!force && busy()) { cleanup(); t = setTimeout(function () { open(reason); }, 4000); return; }
      shown = true;
      cleanup();
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      document.documentElement.classList.add('avp-pop-open');
      track('vip_popup_view', { vip_trigger: reason });
      var inp = pop.querySelector('input[type="email"]');
      if (inp && window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { inp.focus({ preventScroll: true }); }, 300);
    }
    function close(why) {
      if (!pop.classList.contains('is-open')) return;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('avp-pop-open');
      setTimeout(function () { pop.hidden = true; }, 260);
      if (why !== 'signed') { store.set(PAUSE, String(Date.now() + pauseDays * 86400000)); track('vip_popup_close', { vip_close: why }); }
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) {} }
    }
    pop.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-vip-pop-close]');
      if (c) { e.preventDefault(); close(c.getAttribute('data-vip-pop-close') || 'x'); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close('esc'); });
    pop.addEventListener('vip:signed', function () { setTimeout(function () { close('signed'); }, 3500); });
    document.addEventListener('vip:signed', function (e) { if (!pop.contains(e.target)) cleanup(); });
    t = setTimeout(function () { open(force ? 'test' : 'zeit'); }, force ? 300 : delay);
    if (!force) { window.addEventListener('scroll', onScroll, { passive: true }); document.addEventListener('mouseout', onLeave); }
  }

  function init(root) { initCountdowns(root || document); initForms(root || document); initSticky(); initPopup(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
